import {PersonLink, PersonGeneralLink, PersonLinks} from "./PersonLink";
export default PersonLink;
export {
    PersonLink,
    PersonGeneralLink,
    PersonLinks
}